/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_Pcreleasedate2Inputs */

const id_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Rilis PC`)
};

const ms_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Keluaran PC`)
};

const da_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Udgivelsesdato`)
};

const de_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-Veröffentlichungsdatum`)
};

const en_us2_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Release Date`)
};

const es_es2_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento en PC`)
};

const es_mx2_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento en PC`)
};

const fil_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng PC Release`)
};

const fr_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de sortie PC`)
};

const it_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data uscita PC`)
};

const hu_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC megjelenés dátuma`)
};

const nl_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pc-releasedatum`)
};

const no_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-utgivelsesdato`)
};

const pl_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data premiery na PC`)
};

const pt_br2_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Release Date`)
};

const pt_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento no PC`)
};

const ro_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data lansării pe PC`)
};

const fi_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-julkaisupäivä`)
};

const sv_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-releasedatum`)
};

const vi_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày phát hành PC`)
};

const tr_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Çıkış Tarihi`)
};

const cs_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vydání na PC`)
};

const bg_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на издаване за PC`)
};

const ru_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата выхода на ПК`)
};

const uk_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата виходу на ПК`)
};

const ar_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ إصدار PC`)
};

const hi_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC रिलीज़ तारीख़`)
};

const th_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่วางจำหน่าย PC`)
};

const ja_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC リリース日`)
};

const zh_cn2_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Release Date`)
};

const zh_hant1_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Release Date`)
};

const ko_components_comparison_pcreleasedate2 = /** @type {(inputs: Components_Comparison_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Release Date`)
};

/**
* | output |
* | --- |
* | "PC Release Date" |
*
* @param {Components_Comparison_Pcreleasedate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_pcreleasedate2 = /** @type {((inputs?: Components_Comparison_Pcreleasedate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_Pcreleasedate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_pcreleasedate2(inputs)
	if (locale === "ms") return ms_components_comparison_pcreleasedate2(inputs)
	if (locale === "da") return da_components_comparison_pcreleasedate2(inputs)
	if (locale === "de") return de_components_comparison_pcreleasedate2(inputs)
	if (locale === "en-US") return en_us2_components_comparison_pcreleasedate2(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_pcreleasedate2(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_pcreleasedate2(inputs)
	if (locale === "fil") return fil_components_comparison_pcreleasedate2(inputs)
	if (locale === "fr") return fr_components_comparison_pcreleasedate2(inputs)
	if (locale === "it") return it_components_comparison_pcreleasedate2(inputs)
	if (locale === "hu") return hu_components_comparison_pcreleasedate2(inputs)
	if (locale === "nl") return nl_components_comparison_pcreleasedate2(inputs)
	if (locale === "no") return no_components_comparison_pcreleasedate2(inputs)
	if (locale === "pl") return pl_components_comparison_pcreleasedate2(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_pcreleasedate2(inputs)
	if (locale === "pt") return pt_components_comparison_pcreleasedate2(inputs)
	if (locale === "ro") return ro_components_comparison_pcreleasedate2(inputs)
	if (locale === "fi") return fi_components_comparison_pcreleasedate2(inputs)
	if (locale === "sv") return sv_components_comparison_pcreleasedate2(inputs)
	if (locale === "vi") return vi_components_comparison_pcreleasedate2(inputs)
	if (locale === "tr") return tr_components_comparison_pcreleasedate2(inputs)
	if (locale === "cs") return cs_components_comparison_pcreleasedate2(inputs)
	if (locale === "bg") return bg_components_comparison_pcreleasedate2(inputs)
	if (locale === "ru") return ru_components_comparison_pcreleasedate2(inputs)
	if (locale === "uk") return uk_components_comparison_pcreleasedate2(inputs)
	if (locale === "ar") return ar_components_comparison_pcreleasedate2(inputs)
	if (locale === "hi") return hi_components_comparison_pcreleasedate2(inputs)
	if (locale === "th") return th_components_comparison_pcreleasedate2(inputs)
	if (locale === "ja") return ja_components_comparison_pcreleasedate2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_pcreleasedate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_pcreleasedate2(inputs)
	return ko_components_comparison_pcreleasedate2(inputs)
});
export { components_comparison_pcreleasedate2 as "components.comparison.pcReleaseDate" }